import Immutable from 'immutable';

const SkillSuggestionRecord = Immutable.Record({
  skillId: undefined,
  name: undefined,
  score: undefined,
  layeredScore: undefined,
  layeredFullMark: undefined,
  suggestion: undefined,
  isManuallyAdded: undefined,
  selectedRecommendationList: undefined,
});

export default class SkillSuggestion extends SkillSuggestionRecord { }



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/Idp/Suggestions/SkillSuggestion/model.js